import { render, staticRenderFns } from "./footPrice.vue?vue&type=template&id=5ac28682&scoped=true"
import script from "./footPrice.vue?vue&type=script&lang=js"
export * from "./footPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac28682",
  null
  
)

export default component.exports